import { getRTL } from '@fluentui/react/lib/Utilities';

import { RibbonControlGroupDefinitionSet } from '../components/Ribbon/Ribbon.Props';

/**
 * Determines whether there is adequate space in the ribbon to shift content {spaceNeeded} pixels without overflowing the container
 * @param spaceNeeded Number of pixels that the innerContainingElement will grow by.
 * @param outerContainingElement The outer ribbon container. This element holds the entire RibbonBottomBar minus the ribbonModeToggle
 * @param innerContainingElement The inner ribbon container. This element holds the content within the RibbonBottomBar and nothing else. Does not include overflow space at the end of the ControlGroups
 */
export function checkRibbonOffsetSpaceAvailable(
  spaceNeeded: number,
  outerContainingElement: HTMLElement | null,
  innerContainingElement: HTMLElement | null
) {
  if (!outerContainingElement || !innerContainingElement) {
    return false;
  }
  const outerDivRect = outerContainingElement.getBoundingClientRect();
  const innerDivRect = innerContainingElement.getBoundingClientRect();

  if (getRTL()) {
    return innerDivRect.left - outerDivRect.left > spaceNeeded;
  }
  return outerDivRect.right - innerDivRect.right > spaceNeeded;
}

let componentsToMeasure: { [id: string]: HTMLDivElement } = {};

export function getComponentsToMeasure() {
  return componentsToMeasure;
}

export function setComponentToMeasure(id: string, ref: HTMLDivElement) {
  componentsToMeasure[id] = ref;
}

export function resetComponentMaps() {
  componentsToMeasure = {};
}

export interface SpanningOffset {
  componentId: string;
  spanningOffset: number;
  cacheKey: string;
  controlGroups: RibbonControlGroupDefinitionSet;
}

export interface SpanningOffsetDict {
  [tabId: string]: SpanningOffset;
}
